import { TMenuOptions } from "../bannerColors";
import CadastrosMenu from "./Cadastros/Menu";
import CafeMenu from "./Cafe/Menu";
import ComercialMenu from "./Comercial/Menu";
import EstoqueMenu from "./Estoque/Menu";
import FabricaMenu from "./Fabrica/Menu";
import FinanceiroMenu from "./Financeiro/Menu";
import FiscalMenu from "./Fiscal/Menu";
import ReceituarioMenu from "./ReceituarioAgronomico/Menu";

export default function Menus({
    type
}: MenusProps) {

    return (
        <>
            {type === "Financeiro" && <FinanceiroMenu {...{ type }} />}
            {type === "Café" && <CafeMenu {...{ type }} />}
            {type === "Comercial" && <ComercialMenu {...{ type }} />}
            {type === "Cadastros" && <CadastrosMenu {...{ type }} />}
            {type === "Estoque" && <EstoqueMenu {...{ type }} />}
            {type === "Receituário Agronômico" && <ReceituarioMenu {...{type}}/>}
            {type === "Fiscal" && <FiscalMenu {...{type}}/>}
            {type === "Fabrica" && <FabricaMenu {...{type}}/>}

        </>
    )
}

export interface MenusProps {
    type: TMenuOptions
}